import {
  storeUserInfo,
  storeLoggedInFlag,
  logoutUser,
  storeUserCurrentDomain,
  storeUserDeviceInfo,
  isUserLoggedIn,
  getLoggedInUserInfo,
} from "@/services/authService";
import { saveLogToFile } from "@/services/logService";
import _ from "lodash";

export default {
  setUnreadNotificationsCount(state, count) {
  state.unreadNotificationsCount = count;
},
  resetStateToDefault(state) {
    console.log(`resetStateToDefault called`);
    state.domainsList = []; //list of domians/goals in the organization
    state.userCurrentDomain = "";
    state.userCurrentDomainName = "";

    state.learnHierarchyChildNodes = new Map(); //maps of Learn hierechy nodes (app hierarchy nodes)
    state.cloudFrontCookiesResponse = "";

    state.loginError = ""; // indicates if any error is returned by sso token validation api
    state.navDrawer = true;
    state.loading = false;

    //test
    state.userTestCollections = [];
    state.userTestCollectionsLoadedFromServer = false;
    state.tests = [];
    state.testsLoadedFromServer = false;
    state.startTestLoadedFromServer = false;
    state.startTestInfo = {};
    state.currentTestJson = [];
    state.qResponsesState = [];
    state.currentTestState = {
      sectionIndex: 0,
      qIndex: 0,
    };

    //classes
    state.classesList = [];
    state.userMessages = [];
    state.classesListLoadedFromServer = false;
    state.userLoggedIn = "false";

    state.calendarEvents = [];

    // new
    state.isProfileVisible = false;
    state.profileInfo = {};
    state.deleteProfileError = "";
    state.testReportsForCombinedReport = {};
  },

  updateNavDrawer(state, val) {
    state.navDrawer = val;
  },

  loading(state, val) {
    state.loading = val;
  },

  setTempUserLoggedInPhoneNumber(state, val) {
    storeUserDeviceInfo(val);
    state.tempLogInPhoneNumberData = val;
  },

  updateTempPhonenumberLoginData(state, val) {
    state.tempLogInPhoneNumberData = {
      ...state.tempLogInPhoneNumberData,
      ...val,
    };
  },

  emptyTempState(state) {
    state.tempLogInPhoneNumberData = {};
  },

  setAPIUrlsForFlavorAndVersion(state, val) {
    state.app_defaultOrgnizationIdForFlavor = val.organizationId;
    state.app_apiURL = val.apiurl + "/";
    state.app_botConfigurationUrl = val.botConfigurationUrl;
    state.app_boturl = val.boturl;
    state.app_s3url = val.s3url + "/";
    state.app_s3privateUrl = val.s3privateUrl + "/";
    if (val.domainId && val.domainId.length > 0) {
      state.userCurrentDomain = val.domainId;
      storeUserCurrentDomain(val.domainId);
    }
  },

  userTempLoggedIn(state, val) {
    state.tempLoggedIn = val;
  },
  isSSOLogin(state, val) {
    state.isSSOLogin = val;
  },
  clearSSOState(state) {
    state.isSSOLogin = false;
  },
  userLoggedIn(state, val) {
    storeUserInfo(val);
    storeLoggedInFlag(true);
    state.userLoggedIn = "true";
    state.userState = val;
  },

  updateUserLoggedIn(state) {
    state.userLoggedIn = isUserLoggedIn() ?? "false";
    if (state.userLoggedIn == "true") {
      state.appBarVisible = true;
      state.navDrawerVisible = true;
      state.userState = getLoggedInUserInfo();
    }
  },
  logout() {
    logoutUser();
  },
  logoutUserSession(state, val) {
    state.logoutUserSession = val;
  },
  clearLogoutSessionVal(state) {
    state.logoutUserSession = false;
  },
  setLoginError(state, val) {
    state.loginError = val;
  },
  clearLoginError(state) {
    state.loginError = "";
  },
  setProfileDeleteError(state, val) {
    state.deleteProfileError = val;
  },
  storeUserCurrentDomain(state, val) {
    //console.log(`mutating userCurrentDomain: ${val}`);
    state.userCurrentDomain = val;
    storeUserCurrentDomain(val);
  },
  storeUserCurrentDomainName(state, val) {
    state.userCurrentDomainName = val;
  },
  storeUserCurrentDomainFromLocalStorage(state, val) {
    //console.log(`mutating userCurrentDomain from storeUserCurrentDomainFromLocalStorage: ${val}`);
    state.userCurrentDomain = val;
  },
  loadDomainsList(state, val) {
    state.domainsList = val;
  },

  clearLearnHierarchyNodes(state) {
    state.learnHierarchyChildNodes.clear();
  },

  loadLearnHierarchyChildNodes(state, val) {
    state.learnHierarchyChildNodes.set(val.parentNodeId, val.children);
  },

  unlockNextNodeContent(state, val) {
    function updateNextPair(array, currentContentId, newPropertyValue) {
      let currentIndex = array.findIndex(
        (item) => item.contentId === currentContentId
      );
      console.log("found Index");
      for (let i = currentIndex + 1; i < array.length; i++) {
        let nextItem = array[i];
        if (
          nextItem.contentType !== "SUBFOLDER" &&
          nextItem.contentType !== "FOLDER"
        ) {
          console.log("nextItem : ", nextItem);
          setTimeout(() => {
            nextItem.isLocked = newPropertyValue;
          }, 1500);
          return array;
        }
      }
      return array;
    }
    let modifiedArray = updateNextPair(
      state.learnHierarchyChildNodes.get(val.parentId),
      val.children.contentId,
      false
    );
    //console.log("Modified Array is : ", modifiedArray);
    state.learnHierarchyChildNodes.set(val.parentId, modifiedArray);
  },
  loadUserTestCollections(state, val) {
    state.userTestCollections = val;
  },
  userTestCollectionsLoadedFromServer(state, val) {
    state.userTestCollectionsLoadedFromServer = val;
  },
  updateSelectedTest(state, val) {
    state.selectedTest = val;
  },
  updateCurrentTestId(state, val) {
    state.currentTestId = val;
  },
  updateCloudFrontCookieResponse(state, val) {
    state.cloudFrontCookiesResponse = val;
  },
  updateSyncTimer(state, val) {
    state.syncTimerData = val;
  },
  updateSubmissionInfo(state, val) {
    state.submissionInfo = val;
  },
  updateTestRoutingAllowed(state, val) {
    state.testRoutingAllowed = val;
  },
  //homework mutaions
  loadHomeworks(state, val) {
    state.homeworks = val;
  },
  homeworksLoadedFromServer(state, val) {
    state.homeworksLoadedFromServer = val;
  },
  homeworkS3DocumentData(state, val) {
    state.homeworkDocumentS3Data = val;
  },
  addTestToGetReports(state, val) {
    console.log("Test data", val);
    state.currentTestForHomeworkReport = val;
  },
  removeTestFromStateHomework(state) {
    state.currentTestForHomeworkReport = {};
  },
  loadCombinedTestReports(state, val) {
    state.combinedTestReports = val;
  },
  loadStudentCombinedTestReportData(state, val) {
    state.studentCombinedTestReport = val;
  },
  removeCombinedTestReportsData(state) {
    state.combinedTestReports = [];
  },
  //test mutaions
  loadTests(state, val) {
    state.tests = val;
  },
  testsLoadedFromServer(state, val) {
    state.testsLoadedFromServer = val;
  },
  startTest(state, val) {
    state.startTestInfo = val;
    // state.startTestInfo = {
    //   "testurl": "https://innotrail-questionadmin-images.s3.amazonaws.com/q7.json",
    //   "currentTimeStamp": "",
    //   "testInstanceId": "wq12xwae",
    //   "testmetadata": {
    //     "allowSkippingQuestion": true,
    //     "randomizedQuestionOrder": true,
    //     "testDurationInMinutes": 180,
    //     "testRemainingDurationInMinutes": 80,
    //     "testName": "2023 JEE MAINS Test",
    //     "totalQuestion": 100,
    //     "instructions": `HTML file is made up of different elements. <b> An element </b> is a collection of <i> start tag, end tag, attributes and the text between them</i>.
    //       </p><p> <!-- It is a Paragraph tag for creating the paragraph -->
    //       <b> HTML </b> stands for <i> <u> Hyper Text Markup Language. </u> </i> It is used to create a web pages and applications. This language
    //       is easily understandable by the user and also be modifiable. It is actually a Markup language, hence it provides a flexible way for designing the
    //       web pages along with the text.
    //       </p>
    //       HTML file is made up of different elements. <b> An element </b> is a collection of <i> start tag, end tag, attributes and the text between them</i>.
    //       </p><p> <!-- It is a Paragraph tag for creating the paragraph -->
    //       <b> HTML </b> stands for <i> <u> Hyper Text Markup Language. </u> </i> It is used to create a web pages and applications. This language
    //       is easily understandable by the user and also be modifiable. It is actually a Markup language, hence it provides a flexible way for designing the
    //       web pages along with the text.
    //       </p>  `,
    //     "syllabus": "",
    //     "sections": [
    //       {
    //         "sectionId": "s1",
    //         "visibleOnApp": true,
    //         "showSectionInstructions": false,

    //         "sectionName": "s1name",
    //         "order": 20,
    //         "instructions": "wwwwwww",
    //         "restrictMaxQuestion": "",
    //         "maxQuestionToEvaulate": "",
    //         "qOrder": [{ "qId": "s1a1", "order": 30 },
    //         { "qId": "s1a2", "order": 10 }, { "qId": "s1a7", "order": 8 }, { "qId": "s1a6", "order": 30 },
    //         { "qId": "s1a3", "order": 100 }, { "qId": "s1a4", "order": 7 }, { "qId": "s1a5", "order": 30 },
    //         { "qId": "a8", "order": 310 }
    //         ],

    //         "qResponses": [
    //             {
    //               "qId": "a8",
    //               "qType": "1",
    //               "checkedOption": "d",
    //               "checkedOptions": [
    //               ],
    //               "integerOption": "",
    //               "decimalOption": "",
    //               "markForReview": false
    //             },
    //         ]
    //       },
    //       {
    //         "sectionId": "s2",
    //         "sectionName": "s2name",
    //         "order": 10,
    //         "visibleOnApp": true,
    //         "showSectionInstructions": true,

    //         "instructions": "wwwwwwxxxxxxxxxwwww",
    //         "restrictMaxQuestion": "",
    //         "maxQuestionToEvaulate": "",
    //         "qOrder": [],

    //         "qResponses": [
    //           {
    //             "qId": "s2a4",
    //             "qType": "1",
    //             "checkedOption": "d",
    //             "checkedOptions": [

    //             ],
    //             "integerOption": "",
    //             "decimalOption": "",
    //             "markForReview": false
    //           }
    //         ]
    //       },
    //     ],

    //   },

    // }
  },
  startTestLoadedFromServer(state, val) {
    state.startTestLoadedFromServer = val;
  },
  setTestJson(state, val) {
    state.currentTestJson = val;
  },
  updateCurrentTestState(state, val) {
    state.currentTestState = val;
  },
  updateQResponsesState(state) {
    let sections = state.startTestInfo.testmetadata.sections;
    let editedCurrentTestJson = [];

    /// sort question within the sections

    let sIndex = 0;

    for (let item of sections) {
      let qOrder = sections[sIndex].qOrder;

      let sortedQ = [];

      var foundSectionInTestJson = state.currentTestJson.find(
        (x) => x.sectionId == item.sectionId
      );
      editedCurrentTestJson.push(foundSectionInTestJson);

      for (let q of foundSectionInTestJson.questions) {
        var foundQItemInQOrder = qOrder.find((x) => x.qId == q.qId) ?? null;

        sortedQ.push({
          ...q,
          qOrder: foundQItemInQOrder == null ? 0 : foundQItemInQOrder.order,
        });
      }
      editedCurrentTestJson[sIndex].questions = _.orderBy(
        sortedQ,
        ["qOrder"],
        ["asc"]
      );
      sIndex++;
    }

    state.currentTestJson = editedCurrentTestJson;
    // console.log("check", state.currentTestJson);

    let currentTestJson = [];
    let qResponsesState = [];

    let testJson = state.currentTestJson;
    let sectionIndex = 0;
    let qIndex = 0;

    // console.log(testJson);

    for (let sec of sections) {
      qIndex = 0;

      currentTestJson.push({
        sectionId: sec.sectionId,
        index: sectionIndex,
        sectionName: sec.sectionName,
        restrictAttemptToMaxQuestion: sec.restrictAttemptToMaxQuestion,
        maxQuestionToAttempt: sec.maxQuestionToAttempt,
        questions: [],
      });

      qResponsesState.push({
        sectionId: sec.sectionId,
        index: sectionIndex,
        sectionName: sec.sectionName,
        visibleOnApp: sec.visibleOnApp,
        restrictAttemptToMaxQuestion: sec.restrictAttemptToMaxQuestion,
        maxQuestionToAttempt: sec.maxQuestionToAttempt,
        responses: [],
      });
      // console.log(testJson, sectionIndex);

      for (let qItem of testJson[sectionIndex].questions) {
        currentTestJson[sectionIndex].questions.push({
          qNo: qIndex + 1,
          index: qIndex,
          sectionName: sec.sectionName,

          ...qItem,
        });

        var foundQResponse =
          sec.qResponses.find((x) => x.qId == qItem.qId) ?? null;

        if (foundQResponse == null) {
          qResponsesState[sectionIndex].responses.push({
            qNo: qIndex + 1,
            index: qIndex,
            qId: qItem.qId,
            qType: qItem.qType,
            sectionId: qItem.sectionId,
            sectionName: sec.sectionName,
            checkedOption: "",
            checkedOptions: [],
            integerOption: "",
            decimalOption: "",
            markedForReview: false,
          });
        } else {
          qResponsesState[sectionIndex].responses.push({
            qNo: qIndex + 1,
            index: qIndex,
            qId: qItem.qId,
            qType: qItem.qType,
            sectionName: sec.sectionName,
            ...foundQResponse,
            sectionId: qItem.sectionId,
          });
        }

        qIndex++;
      }

      sectionIndex++;
    }

    state.qResponsesState = qResponsesState;
    state.currentTestJson = currentTestJson;
  },
  saveSingleReportData(state, val) {
    state.testReportsForCombinedReport[val.testId] = val;
  },
  clearSingleReportData(state) {
    state.testReportsForCombinedReport = {};
  },
  loadTestReports(state, val) {
    state.testReports = val;
  },
  testReportsLoadedFromServer(state, val) {
    state.testReportsLoadedFromServer = val;
  },
  clearTestReports(state) {
    state.testReports = {};
  },
  loadTestResult(state, val) {
    state.currentTestResult = val;
    //   state.currentTestResult = {
    //     "testInstanceQuestionSummary": {
    //         "correctQuestion": 10,
    //         "incorrectQuestion": 5,
    //         "notAttempted": 20,
    //         "sections": [
    //             {
    //                 "sectionId": "",
    //                 "sectionName": "",
    //                 "questions": [
    //                     {
    //                         "qText": "Choose the correct colour of the product for the following reaction.<br /><img width=100 src=\"20230506/1683328899067-mceclip0.png\" />",
    //                         "sectionId": "s1",
    //                         "qId": "s1a1",
    //                         "qOrder": 2,
    //                         "qType": "1",
    //                         "options": [
    //                             {
    //                                 "key": "a",
    //                                 "value": "Yellow"
    //                             },
    //                             {
    //                                 "key": "b",
    //                                 "value": "White"
    //                             },
    //                             {
    //                                 "key": "c",
    //                                 "value": "Red"
    //                             },
    //                             {
    //                                 "key": "d",
    //                                 "value": "Blue"
    //                             }
    //                         ],
    //                         "isCorrect": null,
    //                         "marks": 34,
    //                         "userAnswerDecimal": "",
    //                         "userAnswerInteger": "",
    //                         "userAnswers": [],
    //                         "userAnswerSingleChoice": "",
    //                         "answers": [],
    //                         "answerSingleChoice": "d",
    //                         "answerDecimalHigh": "",
    //                         "answerDecimalLow": "",
    //                         "answerInteger": "",
    //                         "solution": ""
    //                     },
    //                     {
    //                         "qText": "Consider <math xmlns=\"http://www.w3.org/1998/Math/MathML\"><mi>f</mi><mo>(</mo><mi>x</mi><mo>)</mo><mo>=</mo><msup><mi>tan</mi><mrow><mo>-</mo><mn>1</mn></mrow></msup><mfenced><msqrt><mfrac><mrow><mn>1</mn><mo>+</mo><mi>sin</mi><mi>x</mi></mrow><mrow><mn>1</mn><mo>-</mo><mi>sin</mi><mi>x</mi></mrow></mfrac></msqrt></mfenced><mo>,</mo><mi>x</mi><mo>&#x2208;</mo><mfenced><mrow><mn>0</mn><mo>,</mo><mfrac><mi mathvariant=\"normal\">&#x3C0;</mi><mn>2</mn></mfrac></mrow></mfenced></math>.\nA normal to <math xmlns=\"http://www.w3.org/1998/Math/MathML\"><mi>y</mi><mo>=</mo><mi>f</mi><mo>(</mo><mi>x</mi><mo>)</mo></math> at <math xmlns=\"http://www.w3.org/1998/Math/MathML\"><mo>=</mo><mfrac><mi mathvariant=\"normal\">&#x3C0;</mi><mn>6</mn></mfrac></math>  also passes through the point :\n",
    //                         "order": "20",
    //                         "sectionId": "s1",
    //                         "qId": "s1a2",
    //                         "qType": "2",
    //                         "options": [
    //                             {
    //                                 "key": "a",
    //                                 "value": "<math xmlns=\"http://www.w3.org/1998/Math/MathML\"><mfenced><mrow><mn>0</mn><mo>,</mo><mfrac><mrow><mn>2</mn><mi mathvariant=\"normal\">&#x3C0;</mi></mrow><mn>3</mn></mfrac></mrow></mfenced></math>"
    //                             },
    //                             {
    //                                 "key": "b",
    //                                 "value": "<math xmlns=\"http://www.w3.org/1998/Math/MathML\"><mfenced><mrow><mfrac><mi mathvariant=\"normal\">&#x3C0;</mi><mn>4</mn></mfrac><mo>,</mo><mn>0</mn></mrow></mfenced></math>"
    //                             },
    //                             {
    //                                 "key": "c",
    //                                 "value": "<math xmlns=\"http://www.w3.org/1998/Math/MathML\"><mfenced><mrow><mfrac><mi mathvariant=\"normal\">&#x3C0;</mi><mn>4</mn></mfrac><mo>,</mo><mn>0</mn></mrow></mfenced></math>"
    //                             },
    //                             {
    //                                 "key": "d",
    //                                 "value": "(0, 0)"
    //                             }
    //                         ],
    //                         "isCorrect": false,
    //                         "marks": 34,
    //                         "userAnswerDecimal": "",
    //                         "userAnswerInteger": "",
    //                         "userAnswers": [
    //                             "a",

    //                             "d"
    //                         ],
    //                         "userAnswerSingleChoice": "",
    //                         "answers": [
    //                             "a",
    //                             "d"
    //                         ],
    //                         "answerSingleChoice": "",
    //                         "answerDecimalHigh": "",
    //                         "answerDecimalLow": "",
    //                         "answerInteger": "",
    //                         "solution": ""
    //                     },
    //                     {
    //                         "qText": "K<sub>2</sub>Cr<sub>2</sub>O<sub>7</sub> paper acidified with dilute H<sub>2</sub>SO<sub>4</sub> turns green when exposed to:",
    //                         "order": "20",
    //                         "sectionId": "s1",
    //                         "qId": "s1a3",
    //                         "qType": "1",
    //                         "options": [
    //                             {
    //                                 "key": "a",
    //                                 "value": "Sulphur dioxide"
    //                             },
    //                             {
    //                                 "key": "b",
    //                                 "value": "Carbon dioxide"
    //                             },
    //                             {
    //                                 "key": "c",
    //                                 "value": "Hydrogen sulphide"
    //                             },
    //                             {
    //                                 "key": "d",
    //                                 "value": "Sulphur trioxide"
    //                             }
    //                         ],
    //                         "isCorrect": true,
    //                         "marks": 34,
    //                         "userAnswerDecimal": "",
    //                         "userAnswerInteger": "",
    //                         "userAnswers": [],
    //                         "userAnswerSingleChoice": "a",
    //                         "answers": [],
    //                         "answerSingleChoice": "a",
    //                         "answerDecimalHigh": "",
    //                         "answerDecimalLow": "",
    //                         "answerInteger": "",
    //                         "solution": ""
    //                     },
    //                     {
    //                         "qText": "Match Column I with Column II:<br />\n<table style=\"border-collapse: collapse; width: 100%;\" border=\"1\">\n<tbody>\n<tr>\n<td style=\"width: 50.1818%;\" colspan=\"2\"><strong>Column I</strong></td>\n<td style=\"width: 49.8182%;\" colspan=\"2\"><strong>Column II</strong></td>\n</tr>\n<tr>\n<td style=\"width: 7.45455%;\" width=\"42\">\n<p><strong>I.</strong></p>\n</td>\n<td style=\"width: 42.7273%;\" width=\"240\">\n<p>Reverberatory furnace</p>\n</td>\n<td style=\"width: 7.63834%;\" width=\"36\">\n<p><strong>P.</strong></p>\n</td>\n<td style=\"width: 42.1798%;\" width=\"220\">\n<p>Pig Iron</p>\n</td>\n</tr>\n<tr>\n<td style=\"width: 7.45455%;\" width=\"42\">\n<p><strong>II.</strong></p>\n</td>\n<td style=\"width: 42.7273%;\" width=\"240\">\n<p>Electrolytic cell</p>\n</td>\n<td style=\"width: 7.63834%;\" width=\"36\">\n<p><strong>Q.</strong></p>\n</td>\n<td style=\"width: 42.1798%;\" width=\"220\">\n<p>Aluminum</p>\n</td>\n</tr>\n<tr>\n<td style=\"width: 7.45455%;\" width=\"42\">\n<p><strong>III.</strong></p>\n</td>\n<td style=\"width: 42.7273%;\" width=\"240\">\n<p>Blast furnace</p>\n</td>\n<td style=\"width: 7.63834%;\" width=\"36\">\n<p><strong>R.</strong></p>\n</td>\n<td style=\"width: 42.1798%;\" width=\"220\">\n<p>Silicon</p>\n</td>\n</tr>\n<tr>\n<td style=\"width: 7.45455%;\" width=\"42\">\n<p><strong>IV.</strong></p>\n</td>\n<td style=\"width: 42.7273%;\" width=\"240\">\n<p>Zone refining furnace</p>\n</td>\n<td style=\"width: 7.63834%;\" width=\"36\">\n<p><strong>S.</strong></p>\n</td>\n<td style=\"width: 42.1798%;\" width=\"220\">\n<p>Copper</p>\n</td>\n</tr>\n</tbody>\n</table>\n<p>Choose the correct answer from the options given below :</p>",
    //                         "order": "20",
    //                         "sectionId": "s1",
    //                         "qId": "s1a4",
    //                         "qType": "1",
    //                         "options": [
    //                             {
    //                                 "key": "a",
    //                                 "value": "I &ndash; P ; II &ndash; R ; III &ndash; Q ; IV &ndash; S"
    //                             },
    //                             {
    //                                 "key": "b",
    //                                 "value": "I &ndash; S ; II &ndash; Q ; III &ndash; P ; IV &ndash; R"
    //                             },
    //                             {
    //                                 "key": "c",
    //                                 "value": "I &ndash; R ; II &ndash; S ; III &ndash; P ; IV &ndash; Q&nbsp;"
    //                             },
    //                             {
    //                                 "key": "d",
    //                                 "value": "I &ndash; P ; II &ndash; S ; III &ndash; Q ; IV &ndash; R"
    //                             }
    //                         ],
    //                         "isCorrect": true,
    //                         "marks": 34,
    //                         "userAnswerDecimal": "",
    //                         "userAnswerInteger": "",
    //                         "userAnswers": [],
    //                         "userAnswerSingleChoice": "a",
    //                         "answers": [],
    //                         "answerSingleChoice": "a",
    //                         "answerDecimalHigh": "",
    //                         "answerDecimalLow": "",
    //                         "answerInteger": "",
    //                         "solution": ""
    //                     },
    //                     {
    //                         "qText": "Consider the sulphides HgS, PbS, CuS, Sb<sub>2</sub>S<sub>3</sub>, As<sub>2</sub>S<sub>3</sub> and CdS. Number of these sulphides soluble in 50% HNO<sub>3</sub> is_________ .",
    //                         "order": "20",
    //                         "sectionId": "s1",
    //                         "qId": "s1a5",
    //                         "qType": "3",
    //                         "options": [],
    //                         "isCorrect": null,
    //                         "marks": 34,
    //                         "userAnswerDecimal": "",
    //                         "userAnswerInteger": "",
    //                         "userAnswers": [],
    //                         "userAnswerSingleChoice": "",
    //                         "answers": [],
    //                         "answerSingleChoice": "",
    //                         "answerDecimalHigh": "",
    //                         "answerDecimalLow": "",
    //                         "answerInteger": "12",
    //                         "solution": ""
    //                     },
    //                     {
    //                         "qText": "For some \\(a,\\;b,\\;c,\\;\\in N,\\) let \\(f(x)=ax-3\\) and \\(g(x)=x^b+c,\\;x\\in R\\). If &nbsp;\\({(fog)}^{-1}(x)=\\left(\\frac{x-7}2\\right)^\\frac13\\), then \\((fog)(ac)+(gof)(b)\\) is equal to _________ .",
    //                         "order": "20",
    //                         "sectionId": "s1",
    //                         "qId": "s1a6",
    //                         "qType": "4",
    //                         "options": [],
    //                         "isCorrect": null,
    //                         "marks": 34,
    //                         "userAnswerDecimal": "",
    //                         "userAnswerInteger": "",
    //                         "userAnswers": [],
    //                         "userAnswerSingleChoice": "a",
    //                         "answers": [],
    //                         "answerSingleChoice": "a",
    //                         "answerDecimalHigh": "10",
    //                         "answerDecimalLow": "12",
    //                         "answerInteger": "",
    //                         "solution": "10.5"
    //                     },
    //                     {
    //                         "qText": "<p>Let \\(\\widehat i,\\,\\widehat j\\,and\\,\\widehat k\\) be the unit vectors along the three positive coordinate axes. Let&nbsp;\\(\\vec a=3\\widehat i+\\widehat j-\\widehat k\\)&nbsp;<br />\\(\\vec b=\\widehat i+b_2\\widehat j+b_3\\widehat k\\), \\(b_2,\\,\\,b_3\\in\\mathbb{R}\\)<strong> &nbsp; &nbsp; &nbsp; &nbsp;</strong></p>\n<p><strong>\\(\\vec c=c_1\\widehat i+c_2\\widehat j+c_3\\widehat k\\),</strong> \\(c_1,\\,\\,c_2,\\,\\,b_3\\in\\mathbb{R}\\) &nbsp; &nbsp;</p>\n<p>be three vectors such that \\(b_2b_3&gt;0,\\,\\,\\vec a\\cdot\\vec b=0\\) and \\(\\begin{pmatrix}0&amp;-c_3&amp;c_2\\\\c_3&amp;0&amp;-c_1\\\\-c_2&amp;c_1&amp;0\\\\&amp;{}&amp;{}\\end{pmatrix}\\begin{pmatrix}1\\\\b_2\\\\b_3\\\\\\end{pmatrix}=\\begin{pmatrix}3-c_1\\\\1-c_2\\\\-1-c_3\\\\\\end{pmatrix}\\).</p>\nThen, which of the following is/are TRUE?",
    //                         "order": "20",
    //                         "sectionId": "s1",
    //                         "qId": "s1a7",
    //                         "qType": "2",
    //                         "options": [
    //                             {
    //                                 "key": "a",
    //                                 "value": "\\(\\vec a\\cdot\\vec c=0\\)"
    //                             },
    //                             {
    //                                 "key": "b",
    //                                 "value": "\\(\\vec b\\cdot\\vec c=0\\)"
    //                             },
    //                             {
    //                                 "key": "c",
    //                                 "value": "\\(\\vert\\vec b\\vert\\,\\,&gt;\\sqrt{10}\\)"
    //                             },
    //                             {
    //                                 "key": "d",
    //                                 "value": "\\(\\vert\\vec c\\vert\\,\\,\\leq\\sqrt{11}\\)"
    //                             }
    //                         ],
    //                         "isCorrect": true,
    //                         "marks": 34,
    //                         "userAnswerDecimal": "",
    //                         "userAnswerInteger": "",
    //                         "userAnswers": [
    //                             "a",
    //                             "b"
    //                         ],
    //                         "userAnswerSingleChoice": "",
    //                         "answers": [
    //                             "a",
    //                             "b"
    //                         ],
    //                         "answerSingleChoice": "",
    //                         "answerDecimalHigh": "",
    //                         "answerDecimalLow": "",
    //                         "answerInteger": "",
    //                         "solution": ""
    //                     },
    //                     {
    //                         "qText": "Letdenote \\(\\overline z\\) the complex conjugate of a complex number 𝑧<em>. </em>If 𝑧 is a non-zero complex number for which both real and imaginary parts of \\(\\left(\\overline z^2+\\frac1{z^2}\\right)\\) are integers, then which of the following is/are possible value(s) of |<em>z</em>|?",
    //                         "order": "20",
    //                         "sectionId": "s1",
    //                         "qId": "a8",
    //                         "qType": "1",
    //                         "options": [
    //                             {
    //                                 "key": "a",
    //                                 "value": "\\(\\left(\\frac{43+3\\sqrt{205}}2\\right)^\\frac14\\)"
    //                             },
    //                             {
    //                                 "key": "b",
    //                                 "value": "\\(\\left(\\frac{7+\\sqrt{33}}4\\right)^\\frac14\\)"
    //                             },
    //                             {
    //                                 "key": "c",
    //                                 "value": "\\(\\left(\\frac{9+\\sqrt{65}}4\\right)^\\frac14\\)"
    //                             },
    //                             {
    //                                 "key": "d",
    //                                 "value": "\\(\\vert\\vec c\\vert\\,\\,\\leq\\sqrt{11}\\)"
    //                             }
    //                         ],
    //                         "isCorrect": true,
    //                         "marks": 34,
    //                         "userAnswerDecimal": "",
    //                         "userAnswerInteger": "",
    //                         "userAnswers": [],
    //                         "userAnswerSingleChoice": "a",
    //                         "answers": [],
    //                         "answerSingleChoice": "a",
    //                         "answerDecimalHigh": "",
    //                         "answerDecimalLow": "",
    //                         "answerInteger": "",
    //                         "solution": ""
    //                     }
    //                 ]
    //             }
    //         ]
    //     }

    // }
    state.currentTestResultJson =
      state.currentTestResult.testInstanceQuestionSummary.sections;
  },
  testResultLoadedFromServer(state, val) {
    state.testsLoadedFromServer = val;
  },
  clearTestResult(state) {
    state.currentTestResult = {};
    state.currentTestResultJson = [];
  },
  clearCurrentTestState(state) {
    state.qResponsesState = [];
    state.currentTestState = {
      sectionIndex: 0,
      qIndex: 0,
    };
    state.startTestInfo = {};
    state.currentTestJson = [];
    state.syncTimerData = {};
    state.submissionInfo = {};
  },
  loadClassesList(state, val) {
    state.classesList = val;
  },
  loadUserMessages(state, val) {
    state.userMessages = val;
  },
  userMessagesLoadedFromServer(state, val) {
    state.userMessagesLoadedFromServer = val;
  },
  userMessageUpdated(state, val) {
    state.userMessageUpdated = val;
  },
  toggleDrawer(state, val) {
    state.navDrawer = val;
  },
  loadCalendarList(state, val) {
    // state.calendarEvents.push(val);
    state.calendarEvents = val;
  },
  emptyCalenderEvents(state) {
    state.calendarEvents = [];
  },
  calendarEventsLoadedFromServer(state, val) {
    state.calendarEventsLoadedFromServer = val;
  },

  navbarVisible(state, val) {
    state.navDrawerVisible = val;
  },

  profileVisible(state, val) {
    state.isProfileVisible = val;
  },
  fetchProfileInfo(state, val) {
    state.profileInfo = val;
  },
  updateEmailForDiscourse(state, val) {
    state.profileInfo.organization.email = val;
  },
  profileInfoLoadedFromServer(state, val) {
    state.profileInfoLoadedFromServer = val;
  },
  checkFeatures(state, val){
    state.featuresEnabled = val
  },
  appbarVisible(state, val) {
    state.appBarVisible = val;
  },
  setRefundPolicyPageActive(state, val) {
    state.isRefundPolicyPageActive = val;
  },

  updateTestSeriesState(state, val) {
    state.testSeriesState = val;
  },
  updateSubmitError(state, val) {
    state.submitError = val;
  },
  updateQuestionAttemptError(state, val) {
    state.questionAttemptError = val;
  },
  classesListLoadedFromServer(state, val) {
    state.classesListLoadedFromServer = val;
  },

  setErrorSnackbar(state, val) {
    state.errorSnackbar = val;
  },

  //error logs mution

  ADD_ERROR_LOG(state, log) {
    state.errorLogs.push(log);
    localStorage.setItem("errorLogs", JSON.stringify(state.errorLogs));
  },
  ADD_NETWORK_ERROR_LOG(state, log) {
    state.networkErrorLogs.push(log);
    localStorage.setItem(
      "networkErrorLogs",
      JSON.stringify(state.networkErrorLogs)
    );
  },
  ADD_TEST_ERROR_LOG(state, log) {
    state.testErrorLogs.push(log);
    localStorage.setItem("testErrorLogs", JSON.stringify(state.testErrorLogs));
  },
  async downloadLogsFile(state) {
    console.log("error logs length: ", state.errorLogs.length);
    console.log("network logs length: ", state.networkErrorLogs.length);
    console.log("test logs length: ", state.testErrorLogs.length);

    if (state.errorLogs.length > 0) {
      await saveLogToFile(state.errorLogs, "ui-errorLogs");
      localStorage.setItem("errorLogs", JSON.stringify([]));
      state.errorLogs = [];
    }

    if (state.networkErrorLogs.length > 0) {
      await saveLogToFile(state.networkErrorLogs, "network-errorLogs");
      localStorage.setItem("networkErrorLogs", JSON.stringify([]));
      state.networkErrorLogs = [];
    }

    if (state.testErrorLogs.length > 0) {
      await saveLogToFile(state.testErrorLogs, "test-errorLogs");
      localStorage.setItem("testErrorLogs", JSON.stringify([]));
      state.testErrorLogs = [];
    }
  },
  CLEAR_ERROR_LOG(state) {
    state.errorLogs = [];
    localStorage.setItem("errorLogs", JSON.stringify([]));
  },
  CLEAR_NETWORK_ERROR_LOG(state) {
    state.networkErrorLogs = [];
    localStorage.setItem("networkErrorLogs", JSON.stringify([]));
  },
  CLEAR_TEST_ERROR_LOG(state) {
    state.testErrorLogs = [];
    localStorage.setItem("testErrorLogs", JSON.stringify([]));
  },

  //forms mutations
  setForms(state,forms){
    state.forms = forms;
  }
};
